import { IFilterState, ProductPriceType } from './types';

export const actionButton = {
  buttonWidthVal: 46,
  buttonMarginMobile: '5px',
};

export const PRODUCT_ALERT_MODAL_ID = 'product-alert-modal';

export const PRODUCT_CONTEXT_ID = 'product-page';

export const initialFilterState: IFilterState = {
  showInternational: false,
  showUsedProducts: false,
  showNotInMintCondition: false,
  showUnavailable: false,
  showPickupOnly: true,
};

export const mapOptionsToFilters = {
  showUsedProducts: ProductPriceType.USED_PRODUCT,
  showNotInMintCondition: ProductPriceType.NOT_IN_MINT_CONDITION,
  showPickupOnly: ProductPriceType.PICKUP_ONLY,
  showUnavailable: ProductPriceType.UNAVAILABLE,
};
